import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '../../../configureStore';
import type { IDiagnosticReportGetOne } from '../../interfaces/diagnosticReportGetOne';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { ProcessScrollItem } from '../../../../common/enums/processScrollItem';
import { ReportStatus } from '../../../../common/enums/reportStatus';
import { ToastType } from '../../../../common/enums/toastType';
import { fetchJson } from '../../../store/fetch';
import { serviceConsumersSelector } from '../../../store/serviceConsumers/serviceConsumerActions';
import { translateKey } from '../../../translate';
import { showServiceToast } from '../../../utils/showToast';
import { ReloadEpisode } from '../../pages/episodes/reloadEpisode';
import { Button } from '../common';

interface IRequestReplicateGgzoButtonProps {
    diagnosticReport: IDiagnosticReportGetOne;
    questionnaireName: string;
    reloadProcess?: (reload?: ReloadEpisode) => Promise<void>;
    request: IRequestGetOne;
    scrollToProcessItem: (requestId: string, scrollItem: ProcessScrollItem) => Promise<void>;
}

export function RequestReplicateGgzoButton(props: IRequestReplicateGgzoButtonProps) {
    const [buttonDisabled, setButtonDisabled] = useState(false);

    if (
        !props.reloadProcess ||
        (props.diagnosticReport.reviewStatus !== ReportStatus.open &&
            props.diagnosticReport.reviewStatus !== ReportStatus.closed)
    ) {
        return null;
    }

    const serviceConsumers = useSelector((state: IReduxState) => serviceConsumersSelector(state).serviceConsumers);
    if (
        serviceConsumers.length === 0 ||
        !serviceConsumers.find((item) => item.service.code === props.request.service.code && item.isRequestCreator)
    ) {
        return null;
    }

    return (
        <Button
            color="secondary"
            disabled={buttonDisabled}
            large
            onClick={async () => {
                setButtonDisabled(true);
                const url = `/api/requests/${props.request.id}/replicate`;
                const result = await fetchJson(url, 'POST');

                showServiceToast(
                    ToastType.success,
                    undefined,
                    props.request.service,
                    'request',
                    `Je aanvraag voor ${props.questionnaireName} is verstuurd. Volg de status in je takenlijst.`
                );

                await props.reloadProcess!(ReloadEpisode.reloadAll);
                await props.scrollToProcessItem(result.json.id, ProcessScrollItem.request);
                setButtonDisabled(false);
            }}
            outlined
        >
            {translateKey('diagnosticReport.resend')}
        </Button>
    );
}
